import { IAnalyticsEvent } from '@verv-inc/js-toolkit';
import { IPaymentModalProduct } from 'modules/payment/store/types';

const FunnelOnOnboardingEventName = 'funnel on onboarding';
const QuizName = 'quiz_funnel';

interface GTMOnbFunnelEventTryPaidParameters {
	paymentType: string;
}

interface GTMOnbFunnelEventQuestOnOfferParameters {
	paymentType: string;
}

export const GTMOnboardingFunnelEvent = {
	waitLoaderPage: (): IAnalyticsEvent => ({
		name: FunnelOnOnboardingEventName,
		info: {
			quiz_action: 'waiting for loader',
		},
	}),
	newWaitLoaderPage: (): IAnalyticsEvent => ({
		name: QuizName,
		info: {
			quiz_activity: 'waiting_for_loader',
		},
	}),
	viewResultsPage: (): IAnalyticsEvent => ({
		name: FunnelOnOnboardingEventName,
		info: {
			quiz_action: 'view results page',
		},
	}),
	quizEnd: (): IAnalyticsEvent => ({
		name: FunnelOnOnboardingEventName,
		info: {
			quiz_action: 'quiz end',
		},
	}),
	quizStart: (): IAnalyticsEvent => ({
		name: FunnelOnOnboardingEventName,
		info: {
			quiz_action: 'quiz start',
		},
	}),
	newQuizStart: (quizVersion: string): IAnalyticsEvent => ({
		name: QuizName,
		info: {
			quiz_activity: 'start_quiz',
			quiz_version: quizVersion,
		},
	}),
	showPayment: (): IAnalyticsEvent => {
		return {
			name: FunnelOnOnboardingEventName,
			info: {
				quiz_action: 'view checkout page',
			},
		};
	},
	newShowPayment: (product: string | undefined): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'open_checkout',
				product_name: product,
			},
		};
	},
	showPaywall: (): IAnalyticsEvent => {
		return {
			name: FunnelOnOnboardingEventName,
			info: {
				quiz_action: 'view page with tariffs',
			},
		};
	},
	newShowPaywall: (paymentVersion: string): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'show_payment_page',
				payment_version: paymentVersion,
			},
		};
	},
	showTrialPopup: (paymentVersion: string): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'show_choose_trial_popup',
				payment_version: paymentVersion,
			},
		};
	},
	selectSubscription: (productName: string): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'select_subscription',
				product_name: productName,
			},
		};
	},
	tryPaid: (parameters: GTMOnbFunnelEventTryPaidParameters): IAnalyticsEvent => {
		return {
			name: FunnelOnOnboardingEventName,
			info: {
				quiz_action: 'try paid',
				payment_type: parameters.paymentType,
			},
		};
	},
	paymentIntention: (paymentSistem: string, productName: string | undefined): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'payment_intention',
				payment_sistem: paymentSistem,
				product_name: productName,
			},
		};
	},
	successPaid: (): IAnalyticsEvent => {
		return {
			name: FunnelOnOnboardingEventName,
			info: {
				quiz_action: 'success paid',
			},
		};
	},
	newSuccessPaid: (
		paymentSistem: string,
		subscriptionPrice: string,
		userEmail: string,
		productName: string | undefined,
		promocode: string | undefined,
		pixelValue: string | number | undefined,
	): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'payment_successful',
				payment_sistem: paymentSistem,
				value: subscriptionPrice,
				priceValue: Number(pixelValue),
				email: userEmail,
				product_name: productName,
				promocode_value: promocode,
				pixel_value: `${pixelValue}`,
			},
		};
	},
	questionOnOffer: (parameters: GTMOnbFunnelEventQuestOnOfferParameters): IAnalyticsEvent => {
		return {
			name: FunnelOnOnboardingEventName,
			info: {
				quiz_action: 'question_on_offer',
				payment_type: parameters.paymentType,
			},
		};
	},
	closeHandler: (product: string | undefined): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'close_checkout',
				product_name: product,
			},
		};
	},
	downloadApp: (): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'download_app',
			},
		};
	},
	showPdfUpsale: (pdfVersion: string | undefined): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'show_pdf_upsale',
				pdf_version: pdfVersion,
			},
		};
	},
	showPdfPopup: (): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'show_pdf_popup',
			},
		};
	},
	closePdfUpsale: (): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'close_pdf_upsale',
			},
		};
	},
	choosePdfPopup: (): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'choose_pdf_popup',
			},
		};
	},
	showPdfUpsale2: (pdfVersion: string | undefined): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'show_pdf_upsale_2',
				pdf_version: pdfVersion,
			},
		};
	},
	paymentPdfUpsale: (
		paymentSistem: string,
		price: string,
		email: string,
		productName: string,
	): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'payment_pdf_upsale',
				payment_sistem: paymentSistem,
				value: price,
				email,
				product_name: productName,
			},
		};
	},
	showSpecialOffer: (specialOfferVersion: string): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'show_special_offer',
				special_offer_version: specialOfferVersion,
			},
		};
	},
	chooseSpecialOffer: (): IAnalyticsEvent => {
		return {
			name: QuizName,
			info: {
				quiz_activity: 'choose_special_offer',
			},
		};
	},
};
